import { LoadingButton } from "@mui/lab";
import { Box, Button, Checkbox, Icon, List, ListItem, ListItemIcon, ListItemText, Modal, Typography, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { downloadAndRenameFile, getFileNameFromLink } from "@/utils/allUtils";
import { obtenerNombreInforme } from "@/utils/informeUtils";
import { useLiquidarInformesMutation } from "../../redux/api/informeApi";
import { ICarrito, IInforme } from "../../redux/models/typesInformes";
import { useAppSelector } from "../../redux/store";
import MyToastShow from "../Layout/MyToast";

type ModalLiquidarInformesProps = {
    open: boolean;
    onCancel: () => void;
    informes: IInforme[];
    carrito?: ICarrito;
    onInformesLiquidados: (carritoActualizado: ICarrito) => void;
};
const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    boxShadow: 24,
    p: 4,
};

export type LiquidarInformesArgs = {
    listaDevuelta: number[];
    bool: boolean;
};

const ModalLiquidarInformes = ({
    informes,
    carrito,
    open,
    onCancel,
    onInformesLiquidados,
}: ModalLiquidarInformesProps) => {
    const darkMode = useAppSelector((state) => state.theme.darkTheme);

    const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
    const boxWidth = isMobile ? "100%" : "40rem";

    const [liquidarInformes] = useLiquidarInformesMutation();
    const [loading, setLoading] = useState(false);
    const [IvaChecked, setIvaChecked] = useState(false);

    const handleLiquidar = () => {
        let liquidarInformesArgs: LiquidarInformesArgs = {
            listaDevuelta: informes.map((informe) => informe.id),
            bool: IvaChecked
        };


        setLoading(true);
        liquidarInformes(liquidarInformesArgs).unwrap()
            .then(({ message, data }) => {
                setLoading(false)
                MyToastShow({ message, type: "success" })
                if (data) {
                    const linkValue = data.linkPdfInforme;

                    downloadAndRenameFile(linkValue, getFileNameFromLink(linkValue));
                }
                onInformesLiquidados(data.carrito);
                onCancel()
            })
            .catch((err) => {
                setLoading(false);
                MyToastShow({ message: "Error al liquidar informes", type: "error" });
            });
    }

    const handleCheck = (event: any) => {
        setIvaChecked(event.target.checked);
    };

    return (
        <Modal
            open={open}
            onClose={onCancel}
            aria-labelledby={`liquidar-informes`}
            sx={{
                width: "100%",
            }}
        >
            <Box
                sx={(theme) => ({
                    ...style,
                    width: boxWidth,
                    overflow: "auto",
                    maxHeight: "100%",
                    bgcolor: darkMode ? "#232323" : "#fff",
                })}
                aria-label={`liquidar-container-informes`}
            >
                {carrito && <Typography variant="h4" textAlign='center'>Liquidar Informes del carrito {carrito.idCarrito}</Typography>}
                <List sx={{ width: "100%", mt: 2 }}>
                    {informes.map((informe) => (
                        <ListItem >
                            <ListItemIcon>
                                <Icon>description</Icon>
                            </ListItemIcon>
                            <ListItemText
                                primary={obtenerNombreInforme(informe)}
                            />
                        </ListItem>
                    ))}
                </List>
                <Checkbox
                    checked={IvaChecked}
                    onChange={handleCheck}
                    inputProps={{ 'aria-label': 'Checkbox' }}
                />
                Liquidar con IVA


                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                    <LoadingButton
                        loading={loading}
                        variant="contained"
                        color="error"
                        onClick={() => handleLiquidar()}
                    >

                        Liquidar
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ ml: 1 }}
                        onClick={() => onCancel()}
                    >

                        Cerrar
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ModalLiquidarInformes;
